/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import EXIF from 'exif-js';
import { FileWithPreview } from '../types/file';

const convertToDecimalDegree = (gpsDms: number[], direction: string) => {
  if (!gpsDms) {
    return;
  }
  const [degrees, minutes, seconds] = gpsDms;
  const dd = degrees + (minutes / 60 + seconds / 3600);

  // Don't do anything for N or E
  return direction === 'S' || direction === 'W' ? dd * -1 : dd;
};

export const getFileData = (file: FileWithPreview): Promise<FileWithPreview> =>
  new Promise((resolve) => {
    if (!file || !file.type.startsWith('image')) {
      return resolve(file);
    }
    // @ts-ignore
    EXIF.getData(file, function () {
      if (file.exifdata) {
        const { GPSLongitudeRef, GPSLongitude, GPSLatitude, GPSLatitudeRef } = file.exifdata;
        file.Latitude = convertToDecimalDegree(GPSLatitude, GPSLatitudeRef);
        file.Longitude = convertToDecimalDegree(GPSLongitude, GPSLongitudeRef);
      }
      file.preview = URL.createObjectURL(file);

      resolve(file);
    });
  });
